import { render, staticRenderFns } from "./UserPermissionView.vue?vue&type=template&id=a688c2bc&scoped=true&"
import script from "./UserPermissionView.vue?vue&type=script&lang=js&"
export * from "./UserPermissionView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a688c2bc",
  null
  
)

export default component.exports